const factbox = "_uxsf1pewq29";

export { factbox };
import "./spec.box.comp.style.linaria.module.css";
//# sourceMappingURL=spec.box.comp.style.js.map
